import React, { useEffect, useState } from "react";
import { Routes, Route, Link, BrowserRouter } from "react-router-dom";
import { Pruebas } from "../pages/Otro/Pruebas";
import { AdministracionMunicipalBandeja } from "../pages/PreCalificacion/AdministracionMunicipalBandeja";
import { CrearProceso } from "../pages/ProcesosDeCalificacion/CrearProceso";
import { EditarProceso } from "../pages/ProcesosDeCalificacion/EditarProceso";
import Gestion from "../pages/ProcesosDeCalificacion/Gestion";
import { ListarPorProceso } from "../pages/EtapasDeCalificacion/ListarPorProceso";
import { VerPrecalificacion } from "../pages/PreCalificacion/VerPrecalificacion";
import { ListarPorPrecalificador } from "../pages/PreCalificacion/ListarPorPrecalificador";
import { VerProcesoFuncionario } from "../pages/EtapasDeCalificacion/VerProcesoFuncionario";
import { BuscarCalificacion } from "../pages/Calificacion/BuscarCalificacion";
import { ProcesoPorFuncionario } from "../pages/ProcesosDeCalificacion/ProcesoPorFuncionario";
import { AutorizarPrecalificacion } from "../pages/PreCalificacion/AutorizarPrecalificacion";
import { ListarPendientesValidar } from "../pages/PreCalificacion/ListarPendientesValidar";
import { ValidarPorFuncionario } from "../pages/PreCalificacion/ValidarPorFuncionario";
import { CalificacionesPendientes } from "../pages/Calificacion/CalificacionesPendientes";
import { Ratificar } from "../pages/PreCalificacion/Ratificar";
import { ListarRatificadas } from "../pages/PreCalificacion/ListarRatificadas";
import { Notificaciones } from "../pages/ProcesosDeCalificacion/Notificaciones";
import { AceptarCalificacion } from "../pages/PreCalificacion/AceptarCalificacion";
import { FirmarApelacion } from "../pages/PreCalificacion/FirmarApelacion";
import { ProcesoConformidad } from "../pages/Calificacion/ProcesoConformidad";

import Aside from "../layout/Aside";
import Footer from "../layout/Footer";
import Header from "../layout/Header";
import { VerCalificacion } from "../pages/EtapasDeCalificacion/VerCalificacion";
import { Home } from "../pages/Otro/Home";
import { Permisos } from "../utils/Global";
import { logout } from "../reducers/userSlice";
import { useDispatch } from "react-redux";
import { ClaveUnica } from "../components/Otros/ClaveUnica";
import { PrecalificacionesDelFuncionario } from "../pages/Otro/PrecalificacionesDelFuncionario";
import { DetallePrecalificaciones } from "../pages/Otro/DetallePrecalificaciones";
import { HistorialPrecalificaciones } from "../pages/PreCalificacion/HistorialPrecalificaciones";
import { PrecalificacionesPrecalificador } from "../pages/PreCalificacion/PrecalificacionesPrecalificador";
import { ReportePage } from "../pages/Reportes/ReportePage";
import { SuccessCu } from "../pages/Otro/SuccessCu";

export const DashboardRouter = () => {
  const [menuMobileState, setmenuMobileState] = useState(false);
  const dispatch = useDispatch();

  const inactivityTime = function () {
    var time;
      window.onload = resetTimer;
      document.onmousemove = resetTimer;
      document.onkeypress = resetTimer;
      function resetTimer() {
          clearTimeout(time);
          time=setTimeout(()=>{
              dispatch(logout());
              window.location.href = "/login?errorAuth=timeout";
          },3600000);
      }
  };
  inactivityTime();


  return (
    <div className="d-flex flex-column flex-root">
      <div className="page d-flex flex-row flex-column-fluid">
        <Aside 
        setmenuMobileState={setmenuMobileState}
        menuMobileState={menuMobileState} />
        <div
          className="wrapper d-flex flex-column flex-row-fluid"
          id="kt_wrapper"
        >
          <Header setmenuMobileState={setmenuMobileState} />

          
          <Routes>
            {/**PRUEBAS */}
            <Route path="/pruebas" element={<Pruebas />}></Route>
            <Route path="/pruebas/:nombre" element={<Pruebas />}></Route>
            {/**END PRUEBAS */}

            {/**FORMULARIO CLAVE ÚNICA */}
            <Route
              path="/claveUnica/:rut/:id_precalifiacion/:acuerdo"
              element={<ClaveUnica></ClaveUnica>}
            />

            {/**PARA CAPTURAR EL QUERYSTRING */}
            <Route
              path="/successCu"
              element={<SuccessCu></SuccessCu>}
            />

            {/**
             *  LISTO
             *  FILTRO LISTO
             * RESULTADOS DE LOS FILTROS LISTOS
             * CU 66 PROBLEMA CON EL SERVICIO
             *  Pantalla lista*/}
            <Route
              path="/participacionProceso/:idProcess"
              element={<ListarPorProceso />}
            />

            {/**  Pantalla lista, falta la fecha de la firma con clave única
             *  FUNCIONABA PERO AHORA FALLA EL SERVICIO
             */}

            <Route
              path="/verProcesoFuncionario/:idProcess/:id_participant"
              element={<VerProcesoFuncionario />}
            />

            {/***/}
            {(true || Permisos(["ROL_ADMIN"], "redirigir")) && (
              <Route
                path="/editarProceso/:id_process"
                element={<EditarProceso />}
              />
            )}

            {/***/}
            {(true || Permisos(["ROL_ADMIN"], "redirigir")) && (
              <Route
                path="/reporteProceso/:id_process"
                element={<ReportePage />}
              />
            )}


            {/***/}
            <Route path="/crearProceso" element={<CrearProceso />} />

            {/***/}
            <Route path="/buscarProceso" element={<Gestion />} />

            {/** Listo*/}
            <Route
              path="/administracionMunicipal"
              element={<AdministracionMunicipalBandeja />}
            />

            {/***/}
            <Route
              path="/verPrecalificacion"
              element={<VerPrecalificacion />}
            />

            {/**  NO SE CUAL ES */}
            <Route
              path="/verCalificacion/:idCalificacion"
              element={<VerCalificacion />}
            />
            {/***/}
            <Route
              path="/buscarCalificacion"
              element={<BuscarCalificacion />}
            />

            {/** XXXX REPETIDO */}
            <Route
              path="/procesoPorFuncionario"
              element={<ProcesoPorFuncionario />}
            />

            {/***/
            /** Lista */}
            <Route path="/precalificar" element={<ListarPorPrecalificador />} />

            {/***/
            /* Completa */}
            <Route
              path="/autorizarPrecalificacion/:id_participant/:id_precalificacion/"
              element={<AutorizarPrecalificacion />}
            />

            {/***/
            /* Lista */}
            <Route
              path="/misEvaluaciones"
              element={<ListarPendientesValidar />}
            />

            {/***/
            /* Listo */}
            <Route
              path="/validarEvaluacion/:id_participant/:id_precalifiacion"
              element={<ValidarPorFuncionario />}
            />

            {/***/
            /*No existen los servicios 19-julio*/}
            <Route
              path="/calificacionesPendientes"
              element={<CalificacionesPendientes />}
            />

            {/** */
            /* Listo, falta saber de donde viene ratificationstatus y id_qualifications*/}
            <Route
              path="/ratificar/:id_participant/:id_qualifications/:id_session"
              element={<Ratificar />}
            />

            <Route
              path="/detallePrecalificaciones/:id_participant"
              element={<DetallePrecalificaciones/>}
            />

            

            {/** Listo*/}
            <Route path="/listarRatificadas" element={<ListarRatificadas />} />

            {/***/}
            <Route
              path="/procesoConformidad"
              element={<ProcesoConformidad />}
            />

            {/**
             *  Listo,
             *  Listo,
             *  No existe
             *  no funciona el servicio*/}
            <Route
              path="/notificaciones"
              element={<Notificaciones />}
            />

            {/**   , Falta servicio */}
            <Route
              path="/aceptarCalificacion"
              element={<AceptarCalificacion />}
            />

            {/**
             *Vista lista, falta enlace para ver la firma o firmar
             * El servicio funcionaba y ahora no.
             */}
            <Route
              path="/apelacionesPendientes"
              element={<FirmarApelacion />}
            />

            <Route path="/buscarProceso" element={<Gestion />} />

            <Route path="/misPrecalificaciones" element={<PrecalificacionesDelFuncionario></PrecalificacionesDelFuncionario>} />

             { /* 
            <Route
              path="/Home"
              element={<ListarPendientesValidar />}
            />
            */}

            {
            (Permisos(["ROL_PRECALIFICADOR"])) && (
              <Route
                path="/home"
                element={<ListarPorPrecalificador />}
              />
            )}

            
            {(!Permisos(["ROL_PRECALIFICADOR"])) && (
              <Route path="/home" element={<ListarPendientesValidar />} />
            )}

            {(Permisos(["ROL_PRECALIFICADOR"])) && (
              <Route path="/historialPrecalificaciones" element={<HistorialPrecalificaciones />} />
            )}

            {(Permisos(["ROL_PRECALIFICADOR"])) && (
              <Route path="/precalificacionesPrecalificador/:id_process/:id_officer" element={<PrecalificacionesPrecalificador />} />
            )}


           
            <Route path="/" element={<Home />} />
            <Route path="/*" element={<Home />} />
          </Routes>

          <Footer />
        </div>
      </div>
    </div>
  );
};
